import { fetchIssues } from '~/api/issues';
import { parseGitLabIssueUrl } from '~/common/IssueUrlRegexUtils';

const toFinderIssue = gitlabHostname => ({ title, web_url: webUrl, opened_date: createdAt, labels }) => {
  const { projectPath, iid } = parseGitLabIssueUrl(webUrl, gitlabHostname);

  return {
    title,
    webUrl,
    createdAt,
    fullReference: `${projectPath}#${iid}`,
    labels: { nodes: labels.map(label => ({ title: label })) },
  };
};

export const loadPlatformIssues = async (gitlabHostname, filters = {}) => {
  const { records, metadata } = await fetchIssues(filters);

  return {
    issues: records.map(toFinderIssue(gitlabHostname)),
    totalCount: metadata.total_count,
  };
};
